import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = { class: "form-wizard-container" };
const _hoisted_2 = { class: "d-flex justify-content-between my-3 form-wizard-buttons-container" };
const _hoisted_3 = ["disabled"];
const _hoisted_4 = ["disabled"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Loading = _resolveComponent("Loading");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("form", {
            action: "#",
            ref: "formRef",
            onSubmit: _cache[0] || (_cache[0] = _withModifiers(() => null, ["prevent"]))
        }, [
            _createElementVNode("div", {
                class: _normalizeClass(!_ctx.isLoadedStep ? 'hide' : '')
            }, [
                (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.currentComponent)))
            ], 2),
            (!_ctx.isLoadedStep)
                ? (_openBlock(), _createBlock(_component_Loading, { key: 0 }))
                : _createCommentVNode("", true)
        ], 544),
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", null, [
                (!_ctx.hidePrevButtonOnFirstStep || !_ctx.isFirstStep)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "btn btn-default",
                        onClick: _cache[1] || (_cache[1] =
                            //@ts-ignore
                            (...args) => (_ctx.onClickBack && _ctx.onClickBack(...args))),
                        disabled: !_ctx.canPrevious() || _ctx.isValidando
                    }, " Voltar ", 8, _hoisted_3))
                    : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", null, [
                (_ctx.hasNext() || !_ctx.hideNextButtonOnLastStep)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "btn btn-primary",
                        onClick: _cache[2] || (_cache[2] =
                            //@ts-ignore
                            (...args) => (_ctx.onClickNext && _ctx.onClickNext(...args))),
                        disabled: _ctx.isValidando
                    }, _toDisplayString(_ctx.isLatestStep ? _ctx.labelLatestStepButton : _ctx.labelNextButton), 9, _hoisted_4))
                    : _createCommentVNode("", true)
            ])
        ])
    ]));
}
